import { defineTextStyles } from "@chakra-ui/react-v3";

export const textStyles = defineTextStyles({
  heading: {
    32: {
      value: {
        fontFamily: "heading",
        fontSize: "2xl",
        letterSpacing: "tighter",
        lineHeight: "heading",
      },
    },
    24: {
      value: {
        fontFamily: "heading",
        fontSize: "xl",
        letterSpacing: "tight",
        lineHeight: "heading",
      },
    },
    18: {
      value: {
        fontFamily: "heading",
        fontSize: "lg",
        letterSpacing: "normal",
        lineHeight: "heading",
      },
    },
    16: {
      value: {
        fontFamily: "heading",
        fontSize: "md",
        letterSpacing: "normal",
        lineHeight: "heading",
      },
    },
  },

  body: {
    16: {
      value: {
        fontFamily: "body",
        fontSize: "md",
        letterSpacing: "wider",
        lineHeight: "body",
      },
    },
    14: {
      value: {
        fontFamily: "body",
        fontSize: "sm",
        letterSpacing: "wider",
        lineHeight: "body",
      },
    },
    12: {
      value: {
        fontFamily: "body",
        fontSize: "xs",
        letterSpacing: "wider",
        lineHeight: "body",
      },
    },
    10: {
      value: {
        fontFamily: "body",
        fontSize: "2xs",
        letterSpacing: "wider",
        lineHeight: "body",
      },
    },
  },

  mono: {
    16: {
      value: {
        fontFamily: "mono",
        fontSize: "md",
        letterSpacing: "normal",
        lineHeight: "mono",
      },
    },
    14: {
      value: {
        fontFamily: "mono",
        fontSize: "sm",
        letterSpacing: "normal",
        lineHeight: "mono",
      },
    },
    12: {
      value: {
        fontFamily: "mono",
        fontSize: "xs",
        letterSpacing: "normal",
        lineHeight: "mono",
      },
    },
    10: {
      value: {
        fontFamily: "mono",
        fontSize: "2xs",
        letterSpacing: "normal",
        lineHeight: "mono",
      },
    },
  },
});
